export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-02_01.73eb0f9a.jpg";